import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getALLblog } from "../services/blogService";

const POSTS_PER_PAGE = 6;

export default function BlogPage() {
  const [blogPosts, setBlogPosts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    fetchBlogs();
  }, []);

  const fetchBlogs = async () => {
    try {
      setLoading(true);
      const res = await getALLblog();
      console.log(res.data);
      setBlogPosts(res.data.data);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
  const stripHtml = (html) => {
    const doc = new DOMParser().parseFromString(html, "text/html");
    return doc.body.textContent || "";
  };

  const truncate = (text, limit = 120) => {
    return text.length > limit ? text.slice(0, limit) + "..." : text;
  };
  const totalPages = Math.max(1, Math.ceil(blogPosts.length / POSTS_PER_PAGE));
  const paginatedPosts = blogPosts.slice(
    (currentPage - 1) * POSTS_PER_PAGE,
    currentPage * POSTS_PER_PAGE,
  );

  if (loading) {
    return (
      <div className="flex items-center justify-center py-32">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-gray-200 border-t-[#CAE4C9]" />
      </div>
    );
  }
  return (
    <div>
      <div
        className="w-full h-32 bg-cover bg-center relative flex items-center p-8 border-b border-gray-100 overflow-hidden"
        style={{ backgroundImage: "url(/img/bg/banner18.jpg)" }}
      >
        <nav className="text-xs text-gray-400 font-medium tracking-wide justify-center items-center m-auto text-center">
          <h2 className="text-2xl text-black font-semibold mb-2">Blog</h2>
          <Link to="/" className="hover:text-[#43a047] transition-colors">
            Home
          </Link>
          <span className="mx-2 text-gray-300">/</span>
          <span className="text-gray-600">Blog </span>
        </nav>
      </div>

      <div className="max-w-7xl mx-auto px-4 py-10">
        <div className="flex flex-col lg:flex-row gap-8">
          {/* Main */}
          <div className="flex-1">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {paginatedPosts.map((post) => (
                <article
                  key={post.blog_id}
                  className="bg-white border border-border-color hover:shadow-md transition-shadow group"
                >
                  <div className="overflow-hidden">
                    <Link to={`/blog-details/${post.blog_id}`}>
                      <img
                        src={post.image}
                        alt={post.title}
                        className="w-full h-52 object-cover group-hover:scale-105 transition-transform duration-300"
                      />
                    </Link>
                  </div>
                  <div className="p-5">
                    <p className="text-xs text-gray-400 mb-2">
                      {new Date(post.created_at)
                        .toLocaleDateString("en-GB")
                        .replace(/\//g, "-")}
                    </p>
                    <h4 className="font-bold text-dark mb-3 leading-snug hover:text-primary">
                      <Link to={`/blog-details/${post.blog_id}`}>
                        {post.title}
                      </Link>
                    </h4>
                    <p className="text-sm text-gray-500 leading-relaxed mb-4">
                      {truncate(stripHtml(post.description))}
                    </p>
                    <Link
                      to={`/blog-details/${post.blog_id}`}
                      className="text-xs font-semibold text-primary uppercase tracking-wider hover:underline"
                    >
                      Read More →
                    </Link>
                  </div>
                </article>
              ))}
            </div>

            {/* Pagination — only shows when more than 1 page */}
            {totalPages > 1 && (
              <div className="flex justify-center gap-2 mt-10">
                {/* Prev */}
                <button
                  onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}
                  disabled={currentPage === 1}
                  className="w-9 h-9 text-sm font-medium border border-border-color text-dark hover:bg-primary hover:text-white hover:border-primary transition-colors disabled:opacity-30 disabled:cursor-not-allowed"
                >
                  &lt;
                </button>

                {/* Page numbers */}
                {Array.from({ length: totalPages }, (_, i) => i + 1).map(
                  (n) => (
                    <button
                      key={n}
                      onClick={() => setCurrentPage(n)}
                      className={`w-9 h-9 text-sm font-medium border transition-colors ${
                        currentPage === n
                          ? "bg-primary text-white border-primary"
                          : "border-border-color text-dark hover:bg-primary hover:text-white hover:border-primary"
                      }`}
                    >
                      {n}
                    </button>
                  ),
                )}

                {/* Next */}
                <button
                  onClick={() =>
                    setCurrentPage((p) => Math.min(totalPages, p + 1))
                  }
                  disabled={currentPage === totalPages}
                  className="w-9 h-9 text-sm font-medium border border-border-color text-dark hover:bg-primary hover:text-white hover:border-primary transition-colors disabled:opacity-30 disabled:cursor-not-allowed"
                >
                  &gt;
                </button>
              </div>
            )}
          </div>

          {/* Sidebar */}
          {/* <aside className="lg:w-72 flex-shrink-0 space-y-8">
            <div>
              <h3 className="font-bold text-dark mb-4 pb-2 border-b border-border-color uppercase text-sm tracking-wider">
                Search
              </h3>
              <div className="flex border border-border-color">
                <input
                  type="text"
                  placeholder="Search blog..."
                  className="flex-1 px-3 py-2 text-sm outline-none"
                />
                <button className="px-3 btn-readmore  hover:bg-[#c4f0c1] text-black transition-colors text-sm">
                  Go
                </button>
              </div>
            </div>

            <div>
              <h3 className="font-bold text-dark mb-4 pb-2 border-b border-border-color uppercase text-sm tracking-wider">
                Recent Posts
              </h3>
              <div className="space-y-4">
                {blogPosts.slice(0, 3).map((p) => (
                  <div key={p.blog_id} className="flex gap-3 items-start">
                    <Link
                      to={`/blog-details/${p.blog_id}`}
                      className="flex-shrink-0"
                    >
                      <img
                        src={p.full_image_url || p.image}
                        alt={p.title}
                        className="w-16 h-16 object-cover border border-border-color flex-shrink-0"
                      />
                    </Link>
                    <div>
                      <Link
                        to={`/blog-details/${p.blog_id}`}
                        className="text-xs font-medium text-dark hover:text-primary leading-snug line-clamp-2"
                      >
                        {p.title}
                      </Link>
                      <p className="text-xs text-gray-400 mt-1">
                        {new Date(p.created_at)
                          .toLocaleDateString("en-GB")
                          .replace(/\//g, "-")}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </aside> */}
        </div>
      </div>
    </div>
  );
}
